import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  Link,
  Stack,
  TextField,
  Typography,
} from "@common-ui/ui";
import EditIcon from "@mui/icons-material/Edit";
import { filterAddressByType } from "../../../utils/addresses";
import { AddressComponent } from "./AddressComponent";

export const ClientMoreInfo = ({ customerDetails, customerId }) => {
  const clientName =
    customerDetails?.name !== "" ? customerDetails?.name : "---";
  const clientAccountNumber =
    customerDetails?.account !== "" ? customerDetails?.account : "---";
  const clientEmail =
    customerDetails?.email !== "" ? (
      <Link href={`mailto:${customerDetails?.email}`} underline="none">
        {customerDetails?.email}
      </Link>
    ) : (
      "---"
    );
  const clientPhone =
    customerDetails?.phone !== "" ? customerDetails?.phone : "---";
  const clientWebsite =
    customerDetails?.website !== "" ? (
      <Link href={customerDetails?.website} underline="none" target="_blank">
        {customerDetails?.website}
      </Link>
    ) : (
      "---"
    );
  const clientNotes =
    customerDetails?.notes !== "" ? customerDetails?.notes : "---";
  const billingAddress = filterAddressByType(
    customerDetails?.addresses,
    "Billing"
  );
  const mailingAddress = filterAddressByType(
    customerDetails?.addresses,
    "Building"
  );
  const postalAddress = filterAddressByType(
    customerDetails?.addresses,
    "Postal"
  );
  const shippingAddress = filterAddressByType(
    customerDetails?.addresses,
    "Shipping"
  );

  return (
    <Box component="main">
      <Card sx={{ padding: 2 }} variant="outlined">
        <CardContent>
          <Box sx={{ mb: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <Typography fontSize={18} variant="h4">
                  Client Information
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography fontSize={12} variant="h4" fontWeight="700">
                  Client Name
                </Typography>
                <Typography variant="body2">{clientName}</Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography fontSize={12} variant="h4" fontWeight="700">
                  Account Number
                </Typography>
                <Typography variant="body2">{clientAccountNumber}</Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Box display="flex" justifyContent="flex-end">
                  <IconButton aria-label="edit">
                    <EditIcon />
                  </IconButton>
                </Box>
              </Grid>
              <Grid item xs={12} md={3}></Grid>
              <Grid item xs={12} md={3}>
                <Typography fontSize={12} variant="h4" fontWeight="700">
                  Email
                </Typography>
                <Typography variant="body2">{clientEmail}</Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography fontSize={12} variant="h4" fontWeight="700">
                  Phone
                </Typography>
                <Typography variant="body2">{clientPhone}</Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography fontSize={12} variant="h4" fontWeight="700">
                  Website
                </Typography>
                <Typography variant="body2">{clientWebsite}</Typography>
              </Grid>
              <Grid item xs={12} md={3}></Grid>
              <Grid item xs={12} md={6}>
                <Typography fontSize={12} variant="h4" fontWeight="700">
                  Notes / Comments
                </Typography>
                <TextField
                  disabled
                  autoComplete="off"
                  fullWidth
                  placeholder="Type"
                  margin="normal"
                  sx={{ mt: 0.5 }}
                  name="comments"
                  value={clientNotes}
                  rows={4}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Box>
          <Divider />

          {customerDetails?.addresses.length > 0 && (
            <Box sx={{ mt: 3 }}>
              <Stack sx={{ alignItems: "left" }}>
                <Typography fontSize={18} variant="h4">
                  Address:
                </Typography>
              </Stack>

              {mailingAddress.length > 0 &&
                mailingAddress.map((address) => (
                  <AddressComponent
                    address={address}
                    addressType="Mailing"
                    key={address.id | address.system_id}
                  />
                ))}
              {shippingAddress.length > 0 &&
                shippingAddress.map((address) => (
                  <AddressComponent
                    address={address}
                    addressType="Shipping"
                    key={address.id | address.system_id}
                  />
                ))}
              {billingAddress.length > 0 &&
                billingAddress.map((address) => (
                  <AddressComponent
                    address={address}
                    addressType="Billing"
                    key={address.id | address.system_id}
                  />
                ))}
              {postalAddress.length > 0 &&
                postalAddress.map((address) => (
                  <AddressComponent
                    address={address}
                    addressType="Building"
                    key={address.id | address.system_id}
                  />
                ))}
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};
